"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const BoardName_1 = require("@/common/boards/BoardName");
const RandomMAOptionType_1 = require("@/common/ma/RandomMAOptionType");
const i18n_1 = require("@/client/directives/i18n");
const WikiLinks_1 = require("@/client/utils/WikiLinks");
const boardColorClass = {
    [BoardName_1.BoardName.THARSIS]: 'game-config board-tharsis map',
    [BoardName_1.BoardName.HELLAS]: 'game-config board-hellas map',
    [BoardName_1.BoardName.ELYSIUM]: 'game-config board-elysium map',
    [BoardName_1.BoardName.UTOPIA_PLANITIA]: 'game-config board-utopia-planitia map',
    [BoardName_1.BoardName.VASTITAS_BOREALIS_NOVA]: 'game-config board-vastitas_borealis_nova map',
    [BoardName_1.BoardName.TERRA_CIMMERIA_NOVA]: 'game-config board-terra_cimmeria_nova map',
    [BoardName_1.BoardName.AMAZONIS]: 'game-config board-amazonis map',
    [BoardName_1.BoardName.ARABIA_TERRA]: 'game-config board-arabia_terra map',
    [BoardName_1.BoardName.VASTITAS_BOREALIS]: 'game-config board-vastitas_borealis map',
    [BoardName_1.BoardName.TERRA_CIMMERIA]: 'game-config board-terra_cimmeria map',
    [BoardName_1.BoardName.HOLLANDIA]: 'game-config board-hollandia map',
};
exports.default = (0, vue_1.defineComponent)({
    name: 'game-setup-detail',
    props: {
        playerNumber: {
            type: Number,
            required: true,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
        lastSoloGeneration: {
            type: Number,
            required: true,
        },
    },
    computed: {
        rulebookUrls() {
            return WikiLinks_1.RULEBOOK_URLS;
        },
        isPoliticalAgendasOn() {
            return (this.gameOptions.politicalAgendasExtension !== 'Standard');
        },
        boardColorClass() {
            return boardColorClass[this.gameOptions.boardName];
        },
        escapeVelocityDescription() {
            if (this.gameOptions.escapeVelocity === undefined) {
                return '';
            }
            const ev = this.gameOptions.escapeVelocity;
            return (0, i18n_1.translateTextWithParams)('After ${0} min, reduce ${1} VP every ${2} min. (${3} bonus sec. per action.)', [
                ev.thresholdMinutes.toString(),
                ev.penaltyVPPerPeriod.toString(),
                ev.penaltyPeriodMinutes.toString(),
                ev.bonusSectionsPerAction.toString(),
            ]);
        },
        RandomMAOptionType() {
            return RandomMAOptionType_1.RandomMAOptionType;
        },
    },
});
